import React from 'react';
import { Button, Carousel, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie';
import useMobxStores from 'hooks/useMobxStores';
import { ActionType } from 'mocks/banners.mock';

interface HeroBannerProps {
  actionStyle?: string;
  actionText: string;
  actionType: ActionType;
  actionUrl: string;
  animationUrl?: object;
  description?: string;
  descriptionColor?: string;
  imageAlt: string;
  imageUrl?: string;
  isAnimation?: boolean;
  openActionInNewTab?: boolean;
  title: string;
  titleColor?: string;
}

const HeroBanner = ({
  actionStyle = 'primary',
  actionText,
  actionType,
  actionUrl,
  animationUrl = {},
  description = '',
  descriptionColor = 'white',
  imageAlt,
  imageUrl = '../img/RHLSbanner_Tour.png',
  isAnimation = false,
  openActionInNewTab = false,
  title,
  titleColor = 'white',
  ...rest
}: HeroBannerProps) => {
  const { uiStore } = useMobxStores();
  const { t } = useTranslation();

  const showVideo = (video: string) => {
    uiStore.toggleTour(video);
  };

  const animationOptions = {
    animationData: animationUrl,
    autoplay: true,
    loop: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Carousel.Item {...rest}>
      {isAnimation ? (
        <Lottie className="hero-image" options={animationOptions} />
      ) : (
        <img alt={imageAlt} className="hero-image" src={imageUrl} />
      )}

      <Carousel.Caption>
        <div className="container-grid-responsive">
          <Col xs={12}>
            <h2
              style={{
                color: titleColor,
              }}
            >
              {t(title)}
            </h2>
            <div className="text-wrapper">
              <p
                style={{
                  color: descriptionColor || '',
                }}
              >
                {t(description)}
              </p>
            </div>
            <div className="btn-wrapper">
              <Button
                bsStyle={actionStyle || 'primary'}
                data-analytics-id="action-btn-hero-lp"
                type="submit"
                {...(actionType === ActionType.OpenLink && {
                  href: actionUrl,
                })}
                {...(actionType === ActionType.ShowVideo && {
                  onClick: () => {
                    showVideo(actionUrl);
                  },
                })}
                {...(openActionInNewTab && {
                  rel: 'noopener noreferrer',
                  target: '_blank',
                })}
              >
                {t(actionText)}
              </Button>
            </div>
          </Col>
        </div>
      </Carousel.Caption>
    </Carousel.Item>
  );
};

export default HeroBanner;
